/**
 * Prevent Add to Cart for Request Quote Products
 * This script prevents add to cart functionality for products with custom.is_requested_quote metafield set to true
 */

(function() {
  'use strict';

  // Check if product has request quote metafield
  function isRequestQuoteProduct() {
    // Check if product info element has data attribute
    const productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.dataset.isRequestQuote === 'true') {
      return true;
    }

    // Check product form component for data attribute
    const productFormComponent = document.querySelector('product-form-component');
    if (productFormComponent && productFormComponent.dataset.isRequestQuote === 'true') {
      return true;
    }

    // Check product form for data attribute
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm && productForm.dataset.isRequestQuote === 'true') {
      return true;
    }

    // Check body for data attribute (set by Liquid)
    if (document.body.dataset.isRequestQuote === 'true') {
      return true;
    }

    return false;
  }

  // Get product handle for redirect
  function getProductHandle() {
    const productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.dataset.productHandle) {
      return productInfo.dataset.productHandle;
    }
    
    const productFormComponent = document.querySelector('product-form-component');
    if (productFormComponent && productFormComponent.dataset.productHandle) {
      return productFormComponent.dataset.productHandle;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('product') || null;
  }

  // Prevent form submission
  function preventAddToCart(event) {
    if (isRequestQuoteProduct()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Redirect to request quote page
      const productHandle = getProductHandle();
      
      if (productHandle) {
        window.location.href = `/pages/request-quote?product=${productHandle}`;
      } else {
        window.location.href = '/pages/request-quote';
      }
      
      return false;
    }
  }

  // Prevent cart API calls
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    // Check if it's a cart add request
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart_add_url'))) {
      if (isRequestQuoteProduct()) {
        console.warn('Add to cart prevented for request quote product');
        
        // Redirect to request quote page
        const productHandle = getProductHandle();
        
        if (productHandle) {
          window.location.href = `/pages/request-quote?product=${productHandle}`;
        } else {
          window.location.href = '/pages/request-quote';
        }
        
        return Promise.reject(new Error('Add to cart prevented for request quote product'));
      }
    }
    
    return originalFetch.apply(this, args);
  };

  // Prevent form submissions
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.getAttribute('data-type') === 'add-to-cart-form') {
      preventAddToCart(event);
    }
  }, true);

  // Prevent button clicks on add to cart buttons
  document.addEventListener('click', function(event) {
    const target = event.target;
    const button = target.closest('button[name="add"], .add-to-cart-button, .quick-add__submit');
    
    if (button && isRequestQuoteProduct()) {
      // Check if button is inside a form
      const form = button.closest('form[data-type="add-to-cart-form"]');
      if (form) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Redirect to request quote page
        const productHandle = getProductHandle();
        
        if (productHandle) {
          window.location.href = `/pages/request-quote?product=${productHandle}`;
        } else {
          window.location.href = '/pages/request-quote';
        }
        
        return false;
      }
    }
  }, true);

  // Disable add to cart buttons on page load
  document.addEventListener('DOMContentLoaded', function() {
    if (isRequestQuoteProduct()) {
      const addToCartButtons = document.querySelectorAll(
        'button[name="add"], .add-to-cart-button, .quick-add__submit, [data-type="add-to-cart-form"] button[type="submit"]'
      );
      
      addToCartButtons.forEach(button => {
        button.disabled = true;
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.5';
      });
    }
  });
})();
